import type {
  Dictionary,
  UndecoratedUser,
  UndecoratedUserPreference,
} from '@witmetrics/utils';
import { theme } from '@/utils/theme';

export interface ProfilePictureUser extends UndecoratedUser {
  userPreferences?: Dictionary<UndecoratedUserPreference> | null;
}

export const styles = {
  shared: (size: number) => ({ height: size, width: size, fontSize: size / 2 }),
  avatar: {
    backgroundColor: '#94A3B8',
    color: theme.palette['grey-2'].main,
  },
  circularProgress: {
    color: theme.palette['orange-3'].main,
    animationDuration: '2s',
    '& .MuiCircularProgress-circle': {
      animationDuration: '2s',
    },
  },
};

export function getUserLabels(user: { firstname: string; lastname: string }) {
  const { firstname, lastname } = user;
  return {
    name: `${firstname} ${lastname}`,
    initials: `${firstname.slice(0, 1)}${lastname.slice(0, 1)}`.toUpperCase(),
  };
}
